export * from './lib/shared-util-app-config';
